import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SVGFill } from '../../svg';
import { Icon } from '../../icon';
var CropIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref
  }, props), /*#__PURE__*/React.createElement(SVGFill, {
    d: "M40.4999 32.1899H34.6199V15C34.6199 14.6685 34.4883 14.3506 34.2538 14.1162C34.0194 13.8818 33.7015 13.75 33.3699 13.75H16.4399V8.31006C16.4399 7.97854 16.3083 7.66045 16.0739 7.42603C15.8394 7.1916 15.5215 7.06006 15.1899 7.06006C14.8584 7.06006 14.5405 7.1916 14.306 7.42603C14.0716 7.66045 13.9399 7.97854 13.9399 8.31006V13.75H8.20996C7.87844 13.75 7.56047 13.8818 7.32605 14.1162C7.09163 14.3506 6.95996 14.6685 6.95996 15C6.95996 15.3315 7.09163 15.6494 7.32605 15.8838C7.56047 16.1182 7.87844 16.25 8.20996 16.25H13.9399V33.47C13.9399 33.8015 14.0716 34.1196 14.306 34.354C14.5405 34.5884 14.8584 34.72 15.1899 34.72H32.1199V40.3101C32.1199 40.6416 32.2517 40.9594 32.4861 41.1938C32.7205 41.4283 33.0384 41.5601 33.3699 41.5601C33.7015 41.5601 34.0194 41.4283 34.2538 41.1938C34.4883 40.9594 34.6199 40.6416 34.6199 40.3101V34.72H40.4999C40.8315 34.72 41.1494 34.5884 41.3839 34.354C41.6183 34.1196 41.7499 33.8015 41.7499 33.47C41.7499 33.1385 41.6183 32.8206 41.3839 32.5862C41.1494 32.3518 40.8315 32.22 40.4999 32.22V32.1899ZM16.4399 32.1899V16.1899H32.1199V32.1899H16.4399Z"
  }));
});
CropIcon.displayName = 'CropIcon';
CropIcon.defaultProps = {
  'aria-label': 'Crop'
};
export default CropIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/theme/dist/esm/icons/CropIcon/index.js
// module id = 1820
// module chunks = 12